import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { changeScrollBehavior } from 'src/common/helpers';
import { Button, Drawer } from 'src/components/core';
import { TransferModal } from 'src/components/features/common/modals/transferModal';

import { PreferencesModal } from '../modals/preferencesModal';

interface PreferencesDrawerProps {
    isOpen: boolean;
    toggleDrawer: () => void;
}

const StyledDrawer = styled(Drawer)`
    ${({ theme: { colors, typography } }) => `
        .container{
            margin: 8px;
            background: ${colors.background.primary};
            border-radius: 13px;
            .item {
                text-align: center;
                padding: 16px;
                background: transparent;
                box-shadow: none;
                border: none;
                width: 100%;
                color: ${colors.text.primary};
                font-size: ${typography.size.mobile.paragraph.p1};
                font-weight: ${typography.weight.normal};
                :not(:first-child){
                    border-top: 1px solid ${colors.border.dark};
                    border-radius: 0px;
                }
            }
        }
    `}
`;

const PreferencesDrawer: FC<PreferencesDrawerProps> = ({ isOpen, toggleDrawer }) => {
    const { t } = useTranslation();
    const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = useState(false);

    const handleTransferModal = () => {
        setIsTransferModalOpen(!isTransferModalOpen);
        if (!isTransferModalOpen) {
            toggleDrawer();
        }
    };

    const closePreferencesModal = () => {
        setIsPreferencesModalOpen(false);
    };
    const openPreferencesModal = () => {
        toggleDrawer();
        setIsPreferencesModalOpen(true);
    };

    useEffect(() => {
        changeScrollBehavior(isTransferModalOpen);
    }, [isTransferModalOpen]);
    return (
        <>
            {isOpen && (
                <StyledDrawer handleClose={toggleDrawer} anchor="bottom" open={isOpen}>
                    <div className="container">
                        <Button className="item" onClick={handleTransferModal}>
                            {t('transfer')}
                        </Button>
                        <Button className="item" onClick={openPreferencesModal}>
                            {t('trading_preferences')}
                        </Button>
                    </div>
                </StyledDrawer>
            )}
            {isPreferencesModalOpen && (
                <PreferencesModal
                    isOpen={isPreferencesModalOpen}
                    handleClose={closePreferencesModal}
                />
            )}
            {isTransferModalOpen && (
                <TransferModal open={isTransferModalOpen} handleClose={handleTransferModal} />
            )}
        </>
    );
};

export { PreferencesDrawer };
